import { X, ExternalLink } from "lucide-react";
import { useState, useEffect } from "react";

/* Universal top ribbon — "Part of the SocialPulse Network".
   Rendered once in the top of the app shell (above the sticky nav).
   Dismissible per session (localStorage.tp_socialpulse_ribbon_dismissed). */
export default function SocialPulseRibbon() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const d = localStorage.getItem("tp_socialpulse_ribbon_dismissed");
      // Show again after 7 days
      const at = d ? parseInt(d, 10) : 0;
      const week = 7 * 24 * 60 * 60 * 1000;
      if (!at || Date.now() - at > week) setVisible(true);
    } catch { setVisible(true); }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem("tp_socialpulse_ribbon_dismissed", String(Date.now())); }
    catch { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="w-full bg-gradient-to-r from-indigo-700 via-fuchsia-700 to-rose-600 text-white text-[12px] font-500"
      data-testid="socialpulse-network-ribbon">
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center justify-center gap-2">
        <span className="opacity-90">Part of the</span>
        <a href="https://socialpulse.com" target="_blank" rel="noopener noreferrer"
          data-testid="socialpulse-network-link"
          className="inline-flex items-center gap-1 font-800 underline decoration-white/60 underline-offset-2 hover:decoration-white transition-colors">
          SocialPulse Network <ExternalLink className="w-3 h-3" />
        </a>
        <button onClick={dismiss}
          data-testid="socialpulse-ribbon-dismiss"
          className="ml-auto text-white/70 hover:text-white p-1"
          aria-label="Dismiss">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
